import React from "react"
import { srcDefaultImage } from "../../../images"
import styles from "./styles.module.scss"

function UserRedemptionPageHeader({ headerImageURL, welcomeMessage, caption, mainColor }) {
  if (headerImageURL || caption) {
    return (
      <div className={styles.header}>
        {headerImageURL && (
          <div className={styles.logo}>
            {headerImageURL && (
              <img
                src={headerImageURL || srcDefaultImage}
                alt={welcomeMessage} className={!!caption ? styles.logoImg : styles.lonelyLogoImg}
              />
            )}
          </div>
        )}
        {caption && (
          <div className={(caption.length <= 50 ? styles.caption : styles.captionSmall)} style={{ color: mainColor, textAlign: (!!headerImageURL ? 'default' : 'center') }}>
            {caption}
          </div>
        )}
      </div>
    )
  }
  return null;
}

export default UserRedemptionPageHeader
